export const GET_RIMDIAMETERS_STATED = "GET_RIMDIAMETERS_STATED";
export const GET_RIMDIAMETERS = "GET_RIMDIAMETERS";
export const GET_RIMDIAMETERS_ENDED = "GET_RIMDIAMETERS_ENDED";
export const ADD_RIMDIAMETER_STATED = "ADD_RIMDIAMETER_STARTED";
export const ADD_RIMDIAMETER = "ADD_RIMDIAMETER";
export const ADD_RIMDIAMETER_ENDED = "ADD_RIMDIAMETER_ENDED";
export const EDIT_RIMDIAMETER_STATED = "EDIT_RIMDIAMETER_STATED";
export const EDIT_RIMDIAMETER = "EDIT_RIMDIAMETER";
export const EDIT_RIMDIAMETER_ENDED = "EDIT_RIMDIAMETER_ENDED";
export const GET_RIMDIAMETER = "GET_RIMDIAMETER";
export const GET_RIMDIAMETER_STATED = "GET_RIMDIAMETER_STATED";
export const GET_RIMDIAMETER_ENDED = "GET_RIMDIAMETER_ENDED";
export const RESET_RIMDIAMETER = "RESET_RIMDIAMETER";
export const ERROR_RIMDIAMETER = "ERROR_RIMDIAMETER";
export const GET_ALL_RIMDIAMETERS_STATED = "GET_ALL_RIMDIAMETERS_STATED";
export const GET_ALL_RIMDIAMETERS = "GET_ALL_RIMDIAMETERS";
export const GET_ALL_RIMDIAMETERS_ENDED = "GET_ALL_RIMDIAMETERS_ENDED";
